import {
  Dispatch,
  FC,
  SetStateAction,
  useMemo,
} from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import { FooterView } from '../../shared/components/FooterView/FooterView';

const FOOTER_LINKS: {
  id: 'terms' | 'privacy' | 'eula' | 'cookie'
  link: string
}[] = [
  {
    id: 'terms',
    link: `https://fableborne.com/terms`,
  },
  {
    id: 'privacy',
    link: `https://fableborne.com/privacy`,
  },
  {
    id: 'eula',
    link: `https://fableborne.com/eula`,
  },
];

interface FooterProps {
  setShowBanner: Dispatch<SetStateAction<boolean>>;
}

export const Footer: FC<FooterProps> = ({ setShowBanner }) => {
  const { footerTranslations, legalTranslations } = useTranslation();

  const getCookie = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowBanner(true);
  };

  const currentYear = useMemo(() => new Date().getFullYear(), []);
  const links = useMemo(
    () => FOOTER_LINKS.map((link) => ({
      ...link,
      label: legalTranslations[link.id],
    })),
    [legalTranslations],
  );

  return (
    <FooterView
      links={links}
      footerTranslations={footerTranslations}
      currentYear={currentYear}
      discordUrl="https://discord.com/invite/fableborne"
      twitterUrl="https://x.com/fableborne"
      getCookie={getCookie}
    />
  );
};
